const sortTableLinks = document.querySelectorAll('table [data-sort]');
const sortTableForm = document.querySelector('#sortTableForm');

if (sortTableLinks && sortTableForm) {
    sortTableLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const sort = link.dataset.sort;
            const direction = link.dataset.direction;
            const tab = link.dataset.tab;
            const sortInput = sortTableForm.querySelector(`#sort${tab}`);
            const directionInput = sortTableForm.querySelector(`#direction${tab}`);
            if (sortInput && directionInput) {
                sortInput.value = sort;
                directionInput.value = direction;
                sortTableForm.submit();
            }
        })
    });
}